/* @flow */

import jwtDecode from 'jwt-decode';


export const INITIAL_STATE = {
  hasCompletedGettingStartedGuide: false,
  tokensByUserId: {},
  lastRatedVersion: '',
  currentUserId: null,
  logUpError: null,
  isLoggingUp: false,
};

const authTokenUpdate = (state, token) => {
  const currentUserId = jwtDecode(token).id;

  return {
    currentUserId,
    tokensByUserId: { [currentUserId]: token },
  };
};

export default (state: AuthState = INITIAL_STATE, action: AnyAction) => {
  if (action.type === 'LOGUP_SUCCEEDED') {
    const { token } = action.payload;

    return {
      ...state,
      isLoggingUp: false,
      logUpError: null,
      ...authTokenUpdate(state, token),
    };
  } if (action.type === 'persist/REHYDRATE' && action.payload.auth) {
    return {
      ...state,
      ...action.payload.auth,
      logUpError: null,
    };
  } if (action.type === 'AUTH_RENEW_SUCCEEDED') {
    const { token } = action.payload;

    return {
      ...state,
      ...authTokenUpdate(state, token),
    };
  } if (action.type === 'COMPLETED_GETTING_STARTED_GUIDE') {
    return { ...state, hasCompletedGettingStartedGuide: true };
  } if (action.type === 'RATED_APP') {
    const { appVersion } = action.payload;
    return { ...state, lastRatedVersion: appVersion };
  } if (action.type === 'LOGOUT_REQUEST') {
    return { ...state, currentUserId: null, tokensByUserId: {} };
  } if (action.type === 'LOGUP_FAILED') {
    const { error } = action.payload;
    return { ...state, isLoggingUp: false, logUpError: error };
  } if (action.type === 'LOGUP_REQUEST') {
    return { ...state, isLoggingUp: true, logUpError: null };
  }

  return state;
};
